import React, { useState } from "react";

import "assets/scss/components/form/uploadFile.scss";
import { func_validation } from "functions";



export function UploadFile(props) {
    const { 
        className, inputClassName, labelClassName, 
        acceptFileTypes, uploadedFileName, 
        label, helperMsg,
        inputId,
    } = props;

    // Validate props
    let uploadedFileName_validated = func_validation.isStringTrimNotEmpty(uploadedFileName)? uploadedFileName: "Choose File";
    let label_validated = func_validation.isStringTrimNotEmpty(label)? label:"";
    let helperMsg_validated = func_validation.isStringTrimNotEmpty(helperMsg)? helperMsg:"";
    let inputId_validated = func_validation.isStringTrimNotEmpty(inputId)? inputId: func_validation.getStringUniqueId("component-uploadFile");
    let acceptFileTypes_validated = [];
    if (func_validation.isArrayNotEmpty(acceptFileTypes)) {
        acceptFileTypes_validated = acceptFileTypes.map((fileTypes, idx) => {
            return (idx == 0)? fileTypes: "," + fileTypes;
        });
    }

    // States
    const [uniqueId] = useState(inputId_validated);

    function handleOnChange(e) {
        if (props.onChange) props.onChange(e);
    }

    function handleOnClick(e) {
        if (props.onClick) props.onClick(e);
    }

    return (
        <div className={"component-uploadFile " +
                (className? className + " ":"")}>
            {/* Label */}
            <div className="component-uploadFile-label">
                {label_validated}
            </div>

            {/* Input */}
            <div className="component-uploadFile-inputWrapper">
                <input type="file" id={uniqueId}
                    className={"component-uploadFile-input " + 
                        (inputClassName? inputClassName + " ":"")}
                    onChange={handleOnChange}
                    onClick={handleOnClick}
                    accept={acceptFileTypes_validated}
                />
                <label className={"component-uploadFile-placeholder " + 
                            (labelClassName? labelClassName + " ":"")} 
                    htmlFor={uniqueId}
                >
                    {uploadedFileName_validated}
                </label>
            </div>

            {/* Helper Message */}
            <div className="component-uploadFile-helperMsg">
                {helperMsg_validated}
            </div>
        </div>
    )
}